// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dialog[data-v-32c559b2] .body {
  height: calc(var(--vh) * 65);
}
.select-radio-group[data-v-32c559b2] {
  display: flex;
  flex-direction: column;
  width: 100%;
}
.select-radio-group .search-radio-group[data-v-32c559b2] {
  margin-bottom: 15px;
}
.select-radio-group .hor-line[data-v-32c559b2] {
  background: var(--hor-line-color);
}
.select-radio-group .group-list[data-v-32c559b2] {
  width: 100%;
  max-height: calc(var(--vh) * 60);
  overflow: auto;
  padding-bottom: 10px;
}
.select-radio-group .group-list .selected[data-v-32c559b2] {
  color: var(--modal-elem-color);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/modal/SelectRadioGroup.vue"],"names":[],"mappings":"AAAA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;AACA;EACE,WAAW;EACX,gCAAgC;EAChC,cAAc;EACd,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC","sourcesContent":[".dialog[data-v-32c559b2] .body {\n  height: calc(var(--vh) * 65);\n}\n.select-radio-group[data-v-32c559b2] {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n.select-radio-group .search-radio-group[data-v-32c559b2] {\n  margin-bottom: 15px;\n}\n.select-radio-group .hor-line[data-v-32c559b2] {\n  background: var(--hor-line-color);\n}\n.select-radio-group .group-list[data-v-32c559b2] {\n  width: 100%;\n  max-height: calc(var(--vh) * 60);\n  overflow: auto;\n  padding-bottom: 10px;\n}\n.select-radio-group .group-list .selected[data-v-32c559b2] {\n  color: var(--modal-elem-color);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
